import { readInMarketContent } from './read'

export const inMarketContent = {
  read: readInMarketContent,
}
